import { AdminComponent } from './admin/admin/admin.component';
import { VideosComponent } from './videos/videos.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { EventosComponent } from './eventos/eventos.component';
import { BlogComponent } from './blog/blog.component';
import { ProjetosComponent } from './projetos/projetos.component';
import { FotosDaCampanhaComponent } from './fotos-da-campanha/fotos-da-campanha.component';
import { GaleriaComponent } from './galeria/galeria.component';
import { PropostasComponent } from './propostas/propostas.component';
import { TimelineComponent } from './timeline/timeline.component';
import { BibliografiaComponent } from './bibliografia/bibliografia.component';
import { HomeComponent } from './home/home/home.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'admin', component: AdminComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    CommonModule, RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts